import { Button, ShareIcon, useLocalVariant } from "@draftkings/arena-web";
import * as React from "react";
export const ShareBet = React.memo(function ShareBet(props) {
    const { purchaseId, shareBet } = props;
    const shareBetVariant = useLocalVariant("button", {
        root: {
            margin: 0,
            padding: 0,
            border: 0,
            width: "18px",
            height: "18px",
            color: "$gray400",
            backgroundColor: "transparent",
            cursor: "pointer",
        },
    });
    const shareIcon = useLocalVariant("icon", {
        root: {
            width: "18px",
            height: "18px",
        }
    });
    return React.createElement(Button, { variant: shareBetVariant, onClick: shareBet, testId: `share-bet-button-${purchaseId}` },
        React.createElement(ShareIcon, { accessibilityText: props.shareIconTxt, variant: shareIcon }));
});
//# sourceMappingURL=ShareBet.js.map